import { Navigate } from "react-router-dom";
import { getToken } from "@/lib/adminAuth";

// Lightweight client-side guard. Backend always re-checks the JWT on protected calls,
// so this is just a UX fence to redirect unauthenticated visitors to /admin/login.
export default function AdminProtectedRoute({ children }) {
  if (!getToken()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
